import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

const endPoint = 'getSlackUsers/';
const url = apiUrl + endPoint;

export interface GetSlackUsersRequest {
  OrgUUID: string;
}

export interface SlackUserInfo {
  SlackUserId: string;
  Username?: string | null;
  RealName?: string | null;
  DisplayName?: string | null;
  Email?: string | null;
  ImageUrl?: string | null;
  IsAdmin?: boolean;
  IsOwner?: boolean;
  IsBot?: boolean;
  Deleted?: boolean;
  Presence?: string | null;
  Timezone?: string | null;
  GithubUsername?: string | null;
  GitlabUsername?: string | null;
}

export interface GetSlackUsersResponse {
  Users: SlackUserInfo[];
  TotalCount: number;
  Error?: string | null;
}

const getSlackUsers = async (
  req: GetSlackUsersRequest
): Promise<GetSlackUsersResponse | null> => {
  try {
    const response = await postWithAuth(url, {
      OrgUUID: req.OrgUUID,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const raw = await response.json();
    // Handle both JSON string and object responses
    const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return data;
  } catch (err) {
    console.error('Error fetching Slack users:', err);
    return null;
  }
};

export default getSlackUsers;
